import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Modulify Site',
    description: 'Describe what you want. AI builds it live.',
    url: getOrigin()
}